document.addEventListener('DOMContentLoaded', () => {
// toggle dropdowns
    document.querySelectorAll('.collectionAsideDropButton, #collectionAsideMobileToggle').forEach(button => {
        button.addEventListener('click', function () {
            this.classList.toggle('active');
        })
    })

// change the select to the current query if there is any applie
    const location = window.location.href;
    document.querySelectorAll('#collectionSort option').forEach(option => {
        if (location.includes(option.value)) {
            option.selected = true;
        }
    })

})

// Video Playback Control
// const videos = document.querySelectorAll('video');
// if (videos) {
//     videos.forEach(video => {
//         video.addEventListener('click', async function () {
//             if (video.paused === true) {
//                 for (const item of videos) {
//                     await item.pause();
//                 }
//                 await this.play();
//                 return;
//             }
//             await this.pause();
//         });
//     });
// }